import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) return setStatus("error");
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.payment_status === "held") return setStatus("held");
        if (["expired", "failed"].includes(data.payment_status)) return setStatus("error");
      } catch {
        return setStatus("error");
      }
      if (attempts >= 8) return setStatus("timeout");
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen grid place-items-center px-5 pt-20">
      <div className="glass-chroma rounded-3xl p-10 md:p-14 text-center max-w-lg" data-testid="payment-success">
        {status === "checking" && (
          <><Loader2 className="animate-spin text-[#00f0ff] mx-auto mb-6" size={48} /><h1 className="font-display text-4xl uppercase">Confirming Payment…</h1></>
        )}
        {status === "paid" && (
          <><CheckCircle2 className="text-[#00f0ff] mx-auto mb-6" size={64} /><h1 className="font-display text-5xl uppercase chromatic">Payment Confirmed!</h1><p className="text-white/70 font-head mt-4">Your application &amp; payment are locked in. We'll email you next steps shortly. THWIP!</p></>
        )}
        {status === "held" && (
          <><CheckCircle2 className="text-[#ffe600] mx-auto mb-6" size={64} /><h1 className="font-display text-4xl md:text-5xl uppercase text-[#ffe600]">Application Received!</h1><p className="text-white/70 font-head mt-4">We've placed a hold on your card — <b className="text-white">you have not been charged yet</b>. Once our team approves your application, we'll capture the payment. If you're not approved, the hold is released automatically. THWIP!</p></>
        )}
        {(status === "error" || status === "timeout") && (
          <><XCircle className="text-[#ff0055] mx-auto mb-6" size={64} /><h1 className="font-display text-4xl uppercase">Still Processing</h1><p className="text-white/70 font-head mt-4">If you were charged, your payment is safe and will confirm shortly. Contact dondrae@eventism.com if needed.</p></>
        )}
        <Link to="/" className="inline-block mt-8 bg-[#ff0055] text-white font-head font-bold uppercase px-8 py-3 rounded-full glow-magenta hover:scale-105 transition-transform" data-testid="success-home-btn">Back to Home</Link>
      </div>
    </div>
  );
}
